import { Component, input } from '@angular/core';
import { Erfolg1SvgComponent } from '../erfolg-1/erfolg-1.component';
import { Erfolg2SvgComponent } from '../erfolg-2/erfolg-2.component';
import { Erfolg3SvgComponent } from '../erfolg-3/erfolg-3.component';
import { Erfolg4SvgComponent } from '../erfolg-4/erfolg-4.component';

@Component({
  imports: [Erfolg1SvgComponent, Erfolg2SvgComponent, Erfolg3SvgComponent, Erfolg4SvgComponent],
  selector: 'portal-tutorial-svg',
  styleUrl: './tutorial.component.scss',
  templateUrl: './tutorial.component.html',
})
export class TutorialSvgComponent {
  public id = input<string>();
}
